import React, { Component, Fragment } from "react";

class Addlink extends Component {
  render() {
    const { link, history } = this.props;

    return (
      <button
        class="primary pull-right"
        onClick={() =>
          link === "/SmvThread" ? 
          history.push(`${link}`, { action: "add", _id: "" , styleReferenceId : "" , smvId : "" })
          :
          link === "/CostingPage" ? 
          history.push(`${link}`, { action: "add", _id: "" , sampleRequestId : "" })
          : 
          link === "/Trim" ||
          link === "/developmentFabric" ||
          link === "/Sample" ||
          link === "/BNumber" ||
          link === "/developmentSourcing" ||
          link === "/system/Supplier" ||
          link == "/developmentCad" ||
          link == "/CustomerPage" ||
          link == "/StylePage" ||
          link == "/MeetingNote" ||
          link == "/employee" || 
          link == "/permissionRole"
            ? history.push(`${link}`, { action: "add", _id: "" })
            : history.push(`${link}`)
        }
      >
        {" "}
        <span>
          <i class="material-icons vertical-align-middle">add</i> new
        </span>
      </button>
    );
  }
}

export default Addlink;



// WEBPACK FOOTER //
// ./src/components/Common/Addlink.js